import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import ENTITLEMENTS_ORGANIZATION_QUERY, {
	type EntitlementsEntitlementsQuery,
} from '@jira/servicedesk__organization-details/src/__generated__/EntitlementsEntitlementsQuery.graphql.ts';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

const getCustomerServiceOrganizationAri = (
	organizationId: string,
	activationId: string,
): string => {
	return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};

export const EntitlementsEntitlementsQueryResource: RouteResource<
	PreloadedQuery<EntitlementsEntitlementsQuery, Record<string, unknown>>
> = createRelayResource<EntitlementsEntitlementsQuery>({
	type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: ENTITLEMENTS_ORGANIZATION_QUERY,
		variables: {
			organizationId: getCustomerServiceOrganizationAri(
				String(match.params.organizationId),
				tenantContext.activationId,
			),
			cloudId: tenantContext.cloudId,
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
